// extracted by mini-css-extract-plugin
export default {"g-main1":"search_g-main1__ZCpBn","goods-list":"search_goods-list__PocgL"};